export default "__VITE_ASSET__DT5BuXL4__"